// Cart Drawer JavaScript

// Initialize discount code modal
function initDiscountModal() {
	const discountToggle = document.getElementById('discount-code-toggle');
	const discountModal = document.getElementById('discount-code-modal');
	const closeModal = document.getElementById('close-discount-modal');

	if (discountToggle && discountModal && closeModal) {
		// Remove existing listeners to prevent duplicates
		discountToggle.replaceWith(discountToggle.cloneNode(true));
		const newDiscountToggle = document.getElementById('discount-code-toggle');
		
		newDiscountToggle.addEventListener('click', () => {
			discountModal.classList.add('active');
		});

		closeModal.addEventListener('click', () => {
			discountModal.classList.remove('active');
		});

		discountModal.addEventListener('click', (e) => {
			if (e.target === discountModal) {
				discountModal.classList.remove('active');
			}
		});
	}
}

// Apply Discount
function applyDiscount() {
	const discountCode = document.getElementById("discountCode").value;
	
	if(discountCode) {
		const discountModal = document.getElementById('discount-code-modal');
		// Close the modal first
		if (discountModal) {
			discountModal.classList.remove('active');
		}
		
		// Store flag to reopen cart after reload
		sessionStorage.setItem('reopenCart', 'true');
		
		// Apply the discount
		window.location.href = '/discount/' + discountCode;
	}
}

// Initialize Klaviyo form modal
function initKlaviyoModal() {
	const klaviyoToggle = document.getElementById('klaviyo-form-toggle');
	const klaviyoModal = document.getElementById('klaviyo-form-modal');
	const closeModal = document.getElementById('close-klaviyo-modal');

	if (klaviyoToggle && klaviyoModal && closeModal) {
		// Remove existing listeners to prevent duplicates
		klaviyoToggle.replaceWith(klaviyoToggle.cloneNode(true));
		const newKlaviyoToggle = document.getElementById('klaviyo-form-toggle');
		
		newKlaviyoToggle.addEventListener('click', () => {
			klaviyoModal.classList.add('active');
		});

		closeModal.addEventListener('click', () => {
			klaviyoModal.classList.remove('active');
		});

		klaviyoModal.addEventListener('click', (e) => {
			if (e.target === klaviyoModal) {
				klaviyoModal.classList.remove('active');
			}
		});
	}
}

// Initialize gift drawer
function initGiftDrawer() {
	const openGiftDrawer = document.querySelector('.open_gift_drawer');
	const giftDrawer = document.querySelector('.gift-drawer');
	
	if (openGiftDrawer && giftDrawer) {
		openGiftDrawer.addEventListener('click', () => {
			giftDrawer.classList.add('open');
		});
	}
}

// Reopen cart drawer after applying discount
function checkReopenCart() {
	if (sessionStorage.getItem('reopenCart') === 'true') {
		sessionStorage.removeItem('reopenCart');
		setTimeout(function() {
			const cartDrawer = document.getElementById('Cart-Drawer');
			if (cartDrawer) {
				cartDrawer.classList.add('active');
				document.body.classList.add('open-cart');
				document.body.classList.add('open-cc');
			}
		}, 100);
	}
}

// Initialize all cart drawer functionality
function initCartDrawer() {
	initDiscountModal();
	initKlaviyoModal();
	initGiftDrawer();
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initCartDrawer);
} else {
	initCartDrawer();
}

// Check for cart reopen
checkReopenCart();

// Reinitialize when cart drawer updates
document.addEventListener('cart:refresh', function() {
	setTimeout(initCartDrawer, 100);
});

// Also listen for cart drawer open event
document.addEventListener('cart-drawer:open', function() {
	setTimeout(initCartDrawer, 100);
});

// GWP tooltip: centre the bubble over the (i) icon, but keep it inside the GWP box.
// Delegated so it keeps working after the cart drawer re-renders.
(function() {
	function positionGwpTooltip(wrapper) {
		const trigger = wrapper.querySelector('.enamel_gwp_tooltip-trigger');
		const tip = wrapper.querySelector('.enamel_gwp_tooltip-text');
		const box = wrapper.closest('.enamel_gwp_parent, .enamel_upsell_parent');
		if (!trigger || !tip || !box) return;

		const gutter = 16;
		const boxRect = box.getBoundingClientRect();
		const wrapperRect = wrapper.getBoundingClientRect();
		const iconRect = trigger.getBoundingClientRect();
		const tipWidth = Math.min(240, boxRect.width - gutter * 2);
		const iconCenter = iconRect.left + iconRect.width / 2;
		const minLeft = boxRect.left + gutter;
		const maxLeft = boxRect.right - gutter - tipWidth;
		const tipLeft = Math.max(minLeft, Math.min(iconCenter - tipWidth / 2, maxLeft));

		tip.style.width = tipWidth + 'px';
		wrapper.style.setProperty('--tip-left', (tipLeft - wrapperRect.left) + 'px');
		wrapper.style.setProperty('--tip-arrow', (iconCenter - tipLeft) + 'px');
	}

	['mouseover', 'focusin', 'click'].forEach(function(type) {
		document.addEventListener(type, function(event) {
			const wrapper = event.target.closest && event.target.closest('.enamel_gwp_tooltip');
			if (wrapper) positionGwpTooltip(wrapper);
		});
	});
})();

// GWP + upsell carousels: arrows in the heading scroll the card row one card at a time.
// Delegated + observed so it keeps working after the cart drawer re-renders.
(function() {
	const PARENT = '.enamel_gwp_parent, .enamel_upsell_parent';
	const TRACK = '.enamel_gwp, .enamel_upsell';

	function getTrack(parent) {
		return parent.querySelector(TRACK);
	}

	function updateCarousel(parent) {
		const track = getTrack(parent);
		const nav = parent.querySelector('.enamel_carousel-nav');
		if (!track || !nav) return;
		const maxScroll = track.scrollWidth - track.clientWidth;
		nav.querySelector('[data-carousel-dir="-1"]').disabled = track.scrollLeft <= 2;
		nav.querySelector('[data-carousel-dir="1"]').disabled = track.scrollLeft >= maxScroll - 2;
	}

	function updateAll() {
		document.querySelectorAll('.cart-drawer ' + PARENT.split(', ').join(', .cart-drawer ')).forEach(updateCarousel);
	}

	document.addEventListener('click', function(event) {
		const arrow = event.target.closest && event.target.closest('.enamel_carousel-arrow');
		if (!arrow) return;
		const parent = arrow.closest(PARENT);
		const track = parent && getTrack(parent);
		if (!track) return;
		const card = track.querySelector('.product-cart-item');
		const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
		const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
		track.scrollBy({ left: step * Number(arrow.dataset.carouselDir), behavior: 'smooth' });
	});

	// scroll does not bubble, so listen in the capture phase
	document.addEventListener('scroll', function(event) {
		const track = event.target;
		if (track.matches && track.matches(TRACK)) {
			const parent = track.closest(PARENT);
			if (parent) updateCarousel(parent);
		}
	}, true);

	let scheduled = false;
	function scheduleUpdate() {
		if (scheduled) return;
		scheduled = true;
		requestAnimationFrame(function() {
			scheduled = false;
			updateAll();
		});
	}

	function observeDrawer() {
		const drawer = document.getElementById('Cart-Drawer');
		if (!drawer) return;
		new MutationObserver(scheduleUpdate).observe(drawer, { childList: true, subtree: true });
		scheduleUpdate();
	}

	document.addEventListener('cart-drawer:open', function() { setTimeout(updateAll, 150); });
	window.addEventListener('resize', scheduleUpdate);
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', observeDrawer);
	} else {
		observeDrawer();
	}
})();

// Gift bag line: add the gift bag in one click, then let the theme re-render the drawer.
(function() {
	document.addEventListener('click', function(event) {
		const button = event.target.closest && event.target.closest('.enamel_giftbag-add');
		if (!button || button.disabled) return;
		event.preventDefault();

		const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
		button.disabled = true;
		button.classList.add('loading');

		fetch(root + 'cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
			body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
		})
			.then(function(response) {
				if (!response.ok) throw new Error('Gift bag could not be added');
				document.dispatchEvent(new CustomEvent('cart:refresh'));
			})
			.catch(function(error) {
				console.error(error);
				button.disabled = false;
				button.classList.remove('loading');
			});
	});
})();

// Compact card "+" (quick view): also opens with Enter / Space
document.addEventListener('keydown', function(event) {
	const plus = event.target.closest && event.target.closest('.product-card-quickview--plus');
	if (plus && (event.key === 'Enter' || event.key === ' ')) {
		event.preventDefault();
		plus.click();
	}
});


// Cart 10% offer: inline accordion.
// Klaviyo renders the form ONCE into #CartKlaviyoFormHolder (outside the drawer, never re-rendered).
// Opening the accordion moves that live form in; closing (or a drawer re-render) puts it back.
(function() {
	const holder = document.getElementById('CartKlaviyoFormHolder');
	if (!holder) return;
	const form = holder.firstElementChild;
	if (!form) return;

	function parkForm() {
		if (form.parentElement !== holder) holder.appendChild(form);
		holder.setAttribute('aria-hidden', 'true');
	}

	document.addEventListener('toggle', function(event) {
		const details = event.target;
		if (!details.classList || !details.classList.contains('klaviyo-cart-accordion')) return;
		const content = details.querySelector('.klaviyo-cart-accordion__content');
		if (details.open && content) {
			content.appendChild(form);
		} else {
			parkForm();
		}
	}, true);

	// the drawer re-renders on cart changes: rescue the form if its accordion was replaced
	const drawer = document.getElementById('Cart-Drawer');
	if (drawer) {
		new MutationObserver(function() {
			if (!document.contains(form) || !form.closest('details[open], #CartKlaviyoFormHolder')) parkForm();
		}).observe(drawer, { childList: true, subtree: true });
	}
})();

// 10% offer fallback (cart + product page):
// if Klaviyo hasn't drawn anything into the inline spot (popup/flyout form type),
// close the empty accordion and let Klaviyo open the form itself.
(function() {
	function formIdFrom(el) {
		const match = el && el.className && el.className.match(/klaviyo-form-([A-Za-z0-9]+)/);
		return match ? match[1] : null;
	}

	document.addEventListener('toggle', function(event) {
		const details = event.target;
		if (!details.open || !details.matches) return;
		if (!details.matches('.klaviyo-cart-accordion, .klaviyo-product-accordion details')) return;

		// give the cart script a moment to move the form in
		setTimeout(function() {
			const form = details.querySelector('[class*="klaviyo-form-"]');
			const isEmpty = !form || form.children.length === 0;
			if (!isEmpty) return;

			const formId = formIdFrom(form) || (document.querySelector('#CartKlaviyoFormHolder [class*="klaviyo-form-"]') && formIdFrom(document.querySelector('#CartKlaviyoFormHolder [class*="klaviyo-form-"]')));
			if (!formId) return;

			details.open = false;
			window._klOnsite = window._klOnsite || [];
			window._klOnsite.push(['openForm', formId]);
		}, 50);
	}, true);
})();

// Compact cards: clicking anywhere on the image opens the quick view (same as the "+")
document.addEventListener('click', function(event) {
	const image = event.target.closest && event.target.closest('.product-cart-item--compact .product-cart-item-image');
	if (!image || event.target.closest('.product-card-quickview--plus')) return;
	const plus = image.querySelector('.product-card-quickview--plus');
	if (plus) {
		event.preventDefault();
		plus.click();
	}
});

// iPhone Safari: keep the cart drawer exactly as tall as the visible area,
// so the checkout button never sits behind the browser's bottom bar (it grows/shrinks while scrolling).
(function() {
	const root = document.documentElement;
	function setCartDrawerHeight() {
		const viewport = window.visualViewport;
		const height = viewport ? viewport.height * (viewport.scale || 1) : window.innerHeight;
		root.style.setProperty('--cart-drawer-height', Math.round(Math.min(height, window.innerHeight)) + 'px');
		root.classList.add('cart-drawer-height-ready');
	}
	setCartDrawerHeight();
	if (window.visualViewport) window.visualViewport.addEventListener('resize', setCartDrawerHeight);
	window.addEventListener('resize', setCartDrawerHeight);
	window.addEventListener('orientationchange', function() { setTimeout(setCartDrawerHeight, 300); });
	document.addEventListener('cart-drawer:open', setCartDrawerHeight);
})();
